'use client';
/* External Imports */

import { Box, Modal, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { GrPlayFill } from 'react-icons/gr';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 */
const PsBannerVideo = ({ sectionContent }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const BannerModal = dynamic(() =>
    import('@app-ps/Components/Banners/BannerModal')
  );
  const desktopImage = sectionContent?.image?.url;
  const mobileImage = sectionContent?.mobileImage?.url;
  const videoUrl = sectionContent?.videoUrl;

  const subtext =
    sectionContent?.subtext?.value?.document?.children?.[0]?.children?.[0]
      ?.value;

  // console.log('sectionContent', sectionContent);
  const titleColor = {
    'ps-programs': '#EDA807',
    'ps-productions': {
      base: '#D45F02', // for base (small screen)
      lg: '#F18128', // for medium screen and above
    },
    '': '#EDA807',
  };

  return (
    <Box
      width={'100%'}
      overflowX="hidden"
      bgColor={'black'}
      overflowY="hidden"
      maxH={
        sectionContent.title === 'Workshops'
          ? { base: '800px', sm: '800px', md: '900px', lg: '800px' }
          : {
              base: '720px',
              sm: '720px',
              md: '900px',
              lg: '720px',
              '2xl': '750px',
            }
      }
      height={
        sectionContent.title === 'Workshops'
          ? { base: '120vh', md: '90vh' } // Same value as default
          : '90vh' // Default value
      }
      paddingBottom={{
        base: '4rem',
        // md: '10rem',
        md: '30%',

        lg: sectionContent.title === 'Workshops' ? '4rem' : '0rem',
      }}
    >
      <Box
        display={{ lg: 'flex' }}
        flexDirection={{ lg: 'row-reverse' }}
        height={{ base: '100%' }}
        justifyContent={{ base: 'center' }}
        alignItems={{ base: 'center' }}
        bgImage={{
          base: mobileImage,
          lg: desktopImage,
        }}
        bgSize={{
          base: '100% 550px',
          sm: 'cover 600px',
          md: 'cover 800px',
          lg: 'cover',
        }}
        bgPosition={{ base: 'top left', lg: 'center' }}
        bgRepeat="no-repeat"
      >
        <Box
          position={'relative'}
          // top={{ base: '30%', sm: '27%', lg: '0', '2xl': '-2%' }}
          // right={{ lg: '0' }}
          // left={{ '2xl': '3.5%' }}
          top={
            sectionContent.title === 'Workshops'
              ? { base: '30%', sm: '27%', lg: '0', xl: '-6%', '2xl': '-4%' } // Same values as default
              : { base: '30%', sm: '27%', lg: '0', '2xl': '-2%' } // Default values
          }
          right={
            sectionContent.title === 'Workshops'
              ? { lg: '0', xl: '1%', '2xl': '0' } // Same value as default
              : { lg: '0' } // Default value
          }
          left={
            sectionContent.title === 'Workshops'
              ? { '2xl': '0' } // Same value as default
              : { '2xl': '3.5%' } // Default value
          }
          width={{ lg: '90%' }}
          // height={'82vh'}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {videoUrl && (
            <Box cursor="pointer" onClick={onOpen} zIndex="2">
              <Box
                height={{ base: '89px', xl: '112px', '2xl': '140px' }}
                width={{ base: '89px', xl: '112px', '2xl': '140px' }}
                opacity={0.8}
                bgColor="#D9D9D9"
                borderRadius="50%"
                // marginLeft={{ '2xl': '4rem', xl: '22rem' }}
                // marginBottom={{ '2xl': '4rem', xl: '3rem' }}
                boxShadow="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  as={GrPlayFill}
                  width={{ base: '33.06px', lg: '41.6px', '2xl': '52px' }}
                  height={{ base: '26.14px', lg: '32.9px', '2xl': '41.12px' }}
                />
              </Box>
            </Box>
          )}
        </Box>
        <Box
          position="absolute"
          bottom="0"
          left="0"
          right="0"
          display={{ base: 'block', lg: 'none' }}
          // height={sectionContent.title === 'Workshops' ? '50%' : '25%'}
          height="50%"
          bgImage="linear-gradient(180deg, rgba(2, 9, 18, 0.00) 0%, rgba(2, 9, 18, 0.8) 40%, #020912 100%)"
        />

        <Box
          px={{ base: '1rem', lg: '1rem' }}
          position={{ base: 'relative', lg: 'relative' }}
          left={{
            '2xl': sectionContent.title === 'Workshops' ? '11%' : '12rem',
            lg: '5rem',
          }}
          bottom={{
            base: sectionContent.title === 'Workshops' ? '-70%' : '-85%',
            md: '-75%',
            lg: '2rem',
          }}
          zIndex={500}
        >
          {/* <Box
            position="absolute"
            bottom="0"
            left="0"
            right="0"
            display={{ base: 'block', lg: 'none' }}
            height="50%" // Adjust this value as needed
            bgGradient="linear(to-t, #020912 0%, rgba(2, 9, 18, 0) 100%)"
          /> */}
          <Box
            mb={{ base: '8px', lg: '1.5rem' }}
            as="h1"
            color={titleColor[sectionContent?.styleType]}
            fontSize={{ base: '2.75rem', md: '3.75rem' }}
            // fontWeight={'700'}
            fontFamily={'var(--FedraSerifDisplay-Bold)'}
            letterSpacing={'0.16px'}
            lineHeight={{ base: '52.8px', md: '72px' }}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {sectionContent?.title}
          </Box>
          <Box
            as="p"
            color={'#DFDFDF'}
            // width={{ xl: '70%', '2xl': '75%', lg: '65%' }}
            width={{
              xl: sectionContent.title === 'Workshops' ? '90%' : '70%',
              '2xl': '75%',
              lg: '65%',
            }}
            textAlign={{ base: 'center', lg: 'left' }}
            fontSize={{ base: '1.125rem', md: '1.25rem' }}
            fontWeight={'400'}
            letterSpacing={'0.32px'}
            lineHeight={{ base: '28.8px', md: '32px' }}
            fontFamily="var(--FedraSansStd-book)"
          >
            {subtext}
          </Box>

          <Modal
            isOpen={isOpen}
            onClose={onClose}
            size={{ base: 'full', md: '6xl' }}
            isCentered
            h={{ base: '295px', md: 'auto' }}
          >
            <ModalOverlay bg="rgba{0, 0, 0, 0.7)" />
            <BannerModal sectionContent={sectionContent} onClose={onClose} />
          </Modal>
        </Box>
      </Box>

      {/* Render the image only for the base breakpoint */}
      {sectionContent.title === 'Workshops' && (
        <Box
          display={{ base: 'flex', lg: 'none' }}
          justifyContent="center"
          mt={{ base: '0rem', sm: '-5%', md: '8rem' }}
          mx="auto"
          maxW="500px"
        >
          <LazyLoadImageComponent
            zIndex={'100'}
            src={`${config.imgPath}/d/46272/1721308215-workshopkolam2.png`}
            alt="Workshop Kolam"
            layout="responsive"
          />
        </Box>
      )}
    </Box>
  );
};

export default PsBannerVideo;
